// SLA colors
export const SLA_GREEN = '#95CD5A'
export const SLA_YELLOW = '#F7C22F'
export const SLA_RED = '#DD5959'
export const SLA_PURPLE = '#766bfc'
export const SLA_GRAY = '#c0c0c0'
export const TRANSPARENT = 'rgba(255, 255, 255, 0)'
export const SENSOR_MONITOR_DATASET_MAX_VALUE_COLORS = ['#FF5B5B', '#D94545']
export const DATASET_COLORS = [
  '#3E66A2',
  '#f2b04c',
  '#4782DB',
  '#DF660F',
  '#966DAF',
  '#7BB672',
  '#518471',
  '#FF9533',
  '#37B6BE',
  '#347DB1',
  '#1D4569',
  '#59A5FE',
  '#D95996',
  '#02325C',
  '#4C72B9',
  '#BA7093',
  '#FCDBDB',
  '#ADACF0',
  '#93BEFF',
  '#908BD6',
  '#5FA695',
]
export const CHART_COLORS = [
  '#234099',
  '#93BEFF',
  '#908BD6',
  '#D95996',
  '#02325C',
  '#4C72B9',
  '#BA7093',
  '#FCDBDB',
  '#ADACF0',
  '#645C93',
  '#B180AE',
  '#D9DADB',
]
export const WHITE = '#ffffff'
export const GREY = '#808080'
export const SKY_BLUE = '#cee7f3'
export const GLACIER = '#81A9BB'
export const BIG_STONE = '#33444B'
export const PURPLE = '#7353CC'
export const PURPLE_RGB = '115, 83, 204'
export const RED = '#EC5457'
export const MAIN_BACKGROUND = '#F5F5F5'
export const GRAY = '#636266'
export const GRAY2 = '#EFEFEF'
export const GRAY3 = '#908F91'
export const GRAY4 = '#FAFAFA'
export const GRAY5 = '#565970'
export const GRAY6 = '#E9E9E9'
export const GRAY7 = '#A1A3B1'
export const GRAY_INFO = '#e0e1e2'

export const DB_DARKBLUE = '#2F387B'
export const DB_PURPLE = '#BA7093'
export const DB_MINT = '#5FA695'
export const DB_AZURE = '#1FB8ED'

export const DELICATE_PINK = '#FEA3A3'
export const HAZY_GRAY = '#8d9ea6'
export const DEEP_ORANGE = '#ff8000'
export const MAIN_GRAY = '#cccccc'
export const LIGHT_GRAY = '#e7e7e7'
export const RAW_ASPHALT = '#546E7A'
export const CLEAN_SKY = '#9ED0E8'
export const MAIN_TEXT = '#303030'
export const ACTIONS_COLOR = '#8A8EB2'
export const SUMMER_SKY = '#23BBEF'
export const SUMMER_SKY_RGB = '35,187,239'
export const LIGHT_BLUE = '#DFF7FF'
export const PRIMARY_TEXT = '#2E2D31'
export const PRIMARY = '#00BCD4'
export const BLACK = '#000000'
export const OLIVINE = '#92BC71'
export const LIGHT_RED = '#FF7272'
export const LIGHT_RED2 = '#FFDEDE'
export const RED2 = '#EF6A6B'
export const SECONDARY_TEXT = '#6B6972'
export const DIVIDER_COLOR = '#EDECEE'
export const BLACK_RGB = '0, 0, 0'
export const LIGHT_PURPLE = '#D3C6F6'
export const BLIND_PURPLE = '#BBBBD2'
export const BLIND_PURPLE_RGB = '187, 187, 210'
export const DARK_PURPLE = '#8083A6'
export const PRIMARY_PURPLE = '#6952F3'
export const DARK_DIVIDER = '#727494'
export const TERTIARY_TEXT = '#94929B'
export const SILVER_LIGHT = '#F3F3F3'
export const GREY_LIGHT = '#C2C3CB'
export const PRIMARY_TEXT_RGB = '46, 45, 49'
export const BACKGROUND_REDESIGN = '#F5F4F5'
export const YELLOW = '#FCDB30'
export const BLUE = '#66A0FF'
export const GREEN = '#83BF47'
export const GRAY_RGB = '86, 89, 112'
export const RED_RGB = '255, 114, 114'
export const HOVER_BLUE = '#3fbcd4'
export const PURPLE_HOVER = '#F1EDFC'
export const BORDER_GRAY = '#ECECEE'
export const BORDER_BLACK = '#262626'
export const BLUE_BACKGROUND = '#EFFBFF'
export const HEADER_GRAY = '#757575'
export const ICON_GREY = '#626266'
